@if (niferHebAgor > 0) {
  <div class="nifer-bwletin">{{ niferHebAgor }}</div>
  <!-- <div class="neges neges-rhybudd mb-4 p-3 cursor-pointer" [routerLink]="['/bwletin'] | localize">
    <fa-icon icon="bell" class="mr-4"></fa-icon> {{ niferHebAgor }} {{ 'ui.bwletinhebeiagor' | translate }}
  </div> -->
}